import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { notify } from "../../utils";
import { NotifyType } from "../../utils/app-config";
import Contaier from "../../components/layout/Container/Container";
import Footer from "../../components/molecules/Footer/Footer";
import LoginHeader from "../../components/molecules/Header/LoginHeader";
import { IAccountRegistration } from "../../typings/models/IAccountRegistration";
import Banner from "../../components/layout/Sections/Banner";
import ReCAPTCHA from "react-google-recaptcha";
import { apexApiService } from "../../services/apexApiService";
import { useConfig } from "../../context/ConfigProvider";
import { PageUrl } from "../../utils/app-config";
import Loader from "../../components/molecules/Loader";
function AccountRegistration() {
  const cfg = useConfig();
  const site_Key: string = cfg.REACT_APP_SITE_KEY ?? "";
  const { CreateEservicesUser } = apexApiService();
  const navigate = useNavigate();
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate()); // Set it to today
  const today = currentDate.toISOString().split("T")[0];
  const minDateObj = new Date();
  minDateObj.setDate(currentDate.getDate() + 180);
  const minValidDate = minDateObj.toISOString().split("T")[0];
  const [foreignIDExpDateError, setForeignIDExpDateError] = useState("");
  const [foreignIDNumber, setForeignIDNumber] = useState("");
  const [foreignIDExpDate, setForeignIDExpDate] = useState("");
  const [foreignIDExpDateUni, setForeignIDExpDateUni] = useState("");
  const [foreignIdCountry, setForeignIDCountry] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [fullName, setFullName] = useState("");
  const { message } = notify();
  const [validEmail, setValidEmail] = useState(true);
  const [validMobile, setValidMobile] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmiting, setSubmiting] = useState(false);
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    setEmail(value);
    if (pattern.test(value)) {
      setValidEmail(true);
    } else {
      if (value === "") {
        setValidEmail(true);
      } else {
        setValidEmail(false);
      }
    }
  };

  const handleMobileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9+\b]+$/;

    setMobile(value);
    if (pattern.test(value)) {
      setValidMobile(true);
    } else {
      if (value === "") {
        setValidMobile(true);
      } else {
        setValidMobile(false);
      }
    }
  };

  // const handleForeignExpiryDateChange = (
  //   event: React.ChangeEvent<HTMLInputElement>
  // ) => {
  //   const selectedDate = event.target.value;
  //   const selectedDateObj = new Date(selectedDate);
  //   const maxdateObj = new Date(maxdate);
  //   const mindateObj = new Date(minDate);
  //   if (maxdateObj >= selectedDateObj) {
  //     setForeignIDExpDate(selectedDate);
  //     const issuedAtTimeSeconds = selectedDateObj.getTime();
  //     setForeignIDExpDateUni(issuedAtTimeSeconds.toString());
  //   } else {
  //     event.preventDefault();
  //     setForeignIDExpDate("");
  //     setForeignIDExpDateUni("");
  //   }
  //   if (mindateObj <= selectedDateObj) {
  //     setForeignIDExpDate(selectedDate);
  //     const issuedAtTimeSeconds = selectedDateObj.getTime();
  //     setForeignIDExpDateUni(issuedAtTimeSeconds.toString());
  //   } else {
  //     event.preventDefault();
  //     setForeignIDExpDate("");
  //     setForeignIDExpDateUni("");
  //   }
  // };

  const handleForeignExpiryDateChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedDate = event.target.value;
    const selectedDateObj = new Date(selectedDate);
    setForeignIDExpDate(selectedDate);
    if (selectedDateObj <= minDateObj) {
      setForeignIDExpDateError(
        "Foreign_id_expiry_date has invalid date value or has validity less than 180 days."
      );
    } else {
      const issuedAtTimeSeconds = selectedDateObj.getTime();
      setForeignIDExpDateUni(issuedAtTimeSeconds.toString());
      setForeignIDExpDateError("");
    }
  };

  const handleforeignIdCountryChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setForeignIDCountry(event.target.value);
  };

  const resetForm = () => {
    setForeignIDNumber("");
    setForeignIDExpDate("");
    setEmail("");
    setMobile("");
    setFullName("");
    setForeignIDCountry("");
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitted(true);

    if (!email || !validEmail) {
      return;
    }

    const reCaptchaResponse = recaptchaRef.current?.getValue();

    if (!reCaptchaResponse) {
      setIsCaptchaValid(false);
      return;
    }
    try {
      let accountRegistration: IAccountRegistration = {
        foreignId: foreignIDNumber,
        foreignIdExpiryDate: foreignIDExpDateUni,
        foreignIdCoi: foreignIdCountry,
        email: email,
        mobile: mobile,
        fullName: fullName,
      };

      setSubmiting(true);
      const response1 = await CreateEservicesUser(accountRegistration);

      if (response1?.status == "SUCCESS") {
        message(NotifyType.Success, "Request Submitted Successfully");
        resetForm();
        navigate(PageUrl.AccountSuccess);
      } else {
        message(
          NotifyType.Error,
          response1?.error?.error_desc ||
            "Unable to submit the registration request. Please try again."
        );
      }
    } catch (err) {
      message(
        NotifyType.Error,
        "Unable to submit the registration request. Please try again."
      );
    } finally {
      setSubmiting(false);
    }
  };

  (function () {
    

    var forms = document.querySelectorAll(".needs-validation");
    Array.prototype.slice.call(forms).forEach(function (form) {
      form.addEventListener(
        "submit",
        function (event: any) {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  })();

  return (
    <>
      <LoginHeader />
      <Contaier>
        <Banner
          name="Application for NParks E-Services Account"
          uiClass="banner-bg"
        />
        <div className="info-heading">
          <div className="inner-content">
            <div className="container d-flex justify-content-center align-items-center">
              <div className="row justify-content-center w-100">
                <div className="col-12 col-md-8 col-lg-6">
                  <div className="tab-content" id="v-pills-tabContent">
                    <form className="needs-validation" onSubmit={handleSubmit}>
                      <div className="col-12 text-center mb-4">
                        <h2>E-Services Account Registration</h2>
                      </div>
                      <div className="inst-cnt mt-2">
                        <div className="mb-2">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            Foreign ID Number <span className="star">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Foreign ID Number"
                            value={foreignIDNumber}
                            maxLength={20}
                            onChange={(e) => setForeignIDNumber(e.target.value)}
                            required
                          />
                          <div className="invalid-feedback">
                            Please provide a Foreign ID Number.
                          </div>
                        </div>
                        <div className="mb-2">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            Foreign ID Expiry Date
                            <span className="star">*</span>
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            id="foreignIDExpDate"
                            value={foreignIDExpDate}
                            onChange={handleForeignExpiryDateChange}
                            onBlur={handleForeignExpiryDateChange}
                            min={today}
                            required
                          />
                          <div className="invalid-feedback">
                            Please select Foreign ID Expiry Date.
                          </div>
                          {foreignIDExpDateError && (
                            <p className="error-message">
                              {foreignIDExpDateError}
                            </p>
                          )}
                        </div>
                        <div className="mb-2">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            Foreign ID Country
                            <span className="star">*</span>
                          </label>
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            id="foreignIdCountry"
                            value={foreignIdCountry}
                            onChange={handleforeignIdCountryChange}
                            required
                          >
                            <option value="">-- Select Country--</option>
                            <option key="AF" value="AF">
                              Afghanistan
                            </option>
                            <option key="AX" value="AX">
                              Aland Islands
                            </option>
                            <option key="AL" value="AL">
                              Albania
                            </option>
                            <option key="DZ" value="DZ">
                              Algeria
                            </option>
                            <option key="AS" value="AS">
                              American Samoa
                            </option>
                            <option key="AD" value="AD">
                              Andorra
                            </option>
                            <option key="AO" value="AO">
                              Angola
                            </option>
                            <option key="AI" value="AI">
                              Anguilla
                            </option>
                            <option key="AQ" value="AQ">
                              Antarctica
                            </option>
                            <option key="AG" value="AG">
                              Antigua and Barbuda
                            </option>
                            <option key="AR" value="AR">
                              Argentina
                            </option>
                            <option key="AM" value="AM">
                              Armenia
                            </option>
                            <option key="AW" value="AW">
                              Aruba
                            </option>
                            <option key="AU" value="AU">
                              Australia
                            </option>
                            <option key="AT" value="AT">
                              Austria
                            </option>
                            <option key="AZ" value="AZ">
                              Azerbaijan
                            </option>
                            <option key="BS" value="BS">
                              Bahamas
                            </option>
                            <option key="BH" value="BH">
                              Bahrain
                            </option>
                            <option key="BD" value="BD">
                              Bangladesh
                            </option>
                            <option key="BB" value="BB">
                              Barbados
                            </option>
                            <option key="BY" value="BY">
                              Belarus
                            </option>
                            <option key="BE" value="BE">
                              Belgium
                            </option>
                            <option key="BZ" value="BZ">
                              Belize
                            </option>
                            <option key="BJ" value="BJ">
                              Benin
                            </option>
                            <option key="BM" value="BM">
                              Bermuda
                            </option>
                            <option key="BT" value="BT">
                              Bhutan
                            </option>
                            <option key="BO" value="BO">
                              Bolivia,Plurinational State of
                            </option>
                            <option key="BQ" value="BQ">
                              Bonaire Sint Eustatius and Saba
                            </option>
                            <option key="BA" value="BA">
                              Bosnia and Herzegovina
                            </option>
                            <option key="BW" value="BW">
                              Botswana
                            </option>
                            <option key="BV" value="BV">
                              Bouvet Island
                            </option>
                            <option key="BR" value="BR">
                              Brazil
                            </option>
                            <option key="IO" value="IO">
                              British Indian Ocean Territory
                            </option>
                            <option key="BN" value="BN">
                              Brunei Darussalam
                            </option>
                            <option key="BG" value="BG">
                              Bulgaria
                            </option>
                            <option key="BF" value="BF">
                              Burkina Faso
                            </option>
                            <option key="BI" value="BI">
                              Burundi
                            </option>
                            <option key="CV" value="CV">
                              Cabo Verde
                            </option>
                            <option key="KH" value="KH">
                              Cambodia
                            </option>
                            <option key="CM" value="CM">
                              Cameroon
                            </option>
                            <option key="CA" value="CA">
                              Canada
                            </option>
                            <option key="KY" value="KY">
                              Cayman Islands
                            </option>
                            <option key="CF" value="CF">
                              Central African Republic
                            </option>
                            <option key="TD" value="TD">
                              Chad
                            </option>
                            <option key="CL" value="CL">
                              Chile
                            </option>
                            <option key="CN" value="CN">
                              China
                            </option>
                            <option key="CX" value="CX">
                              Christmas Island
                            </option>
                            <option key="CC" value="CC">
                              Cocos (Keeling) Islands
                            </option>
                            <option key="CO" value="CO">
                              Colombia
                            </option>
                            <option key="KM" value="KM">
                              Comoros
                            </option>
                            <option key="CG" value="CG">
                              Congo
                            </option>
                            <option key="CD" value="CD">
                              Congo, The Democratic Republic of The
                            </option>
                            <option key="CK" value="CK">
                              Cook Islands
                            </option>
                            <option key="CR" value="CR">
                              Costa Rica
                            </option>
                            <option key="CI" value="CI">
                              Cote d'Ivoire
                            </option>
                            <option key="HR" value="HR">
                              Croatia
                            </option>
                            <option key="CU" value="CU">
                              Cuba
                            </option>
                            <option key="CW" value="CW">
                              Curacao
                            </option>
                            <option key="CY" value="CY">
                              Cyprus
                            </option>
                            <option key="CZ" value="CZ">
                              Czech Republic
                            </option>
                            <option key="DK" value="DK">
                              Denmark
                            </option>
                            <option key="DJ" value="DJ">
                              Djibouti
                            </option>
                            <option key="DM" value="DM">
                              Dominica
                            </option>
                            <option key="DO" value="DO">
                              Dominican Republic
                            </option>
                            <option key="EC" value="EC">
                              Ecuador
                            </option>
                            <option key="EG" value="EG">
                              Egypt
                            </option>
                            <option key="SV" value="SV">
                              El Salvador
                            </option>
                            <option key="GQ" value="GQ">
                              Equatorial Guinea
                            </option>
                            <option key="ER" value="ER">
                              Eritrea
                            </option>
                            <option key="EE" value="EE">
                              Estonia
                            </option>
                            <option key="ET" value="ET">
                              Ethiopia
                            </option>
                            <option key="FK" value="FK">
                              Falkland Islands (Malvinas)
                            </option>
                            <option key="FO" value="FO">
                              Faroe Islands
                            </option>
                            <option key="FJ" value="FJ">
                              Fiji
                            </option>
                            <option key="FI" value="FI">
                              Finland
                            </option>
                            <option key="FR" value="FR">
                              France
                            </option>
                            <option key="GF" value="GF">
                              French Guiana
                            </option>
                            <option key="PF" value="PF">
                              French Polynesia
                            </option>
                            <option key="TF" value="TF">
                              French Southern Territories
                            </option>
                            <option key="GA" value="GA">
                              Gabon
                            </option>
                            <option key="GM" value="GM">
                              Gambia
                            </option>
                            <option key="GE" value="GE">
                              Georgia
                            </option>
                            <option key="DE" value="DE">
                              Germany
                            </option>
                            <option key="GH" value="GH">
                              Ghana
                            </option>
                            <option key="GI" value="GI">
                              Gibraltar
                            </option>
                            <option key="GR" value="GR">
                              Greece
                            </option>
                            <option key="GL" value="GL">
                              Greenland
                            </option>
                            <option key="GD" value="GD">
                              Grenada
                            </option>
                            <option key="GP" value="GP">
                              Guadeloupe
                            </option>
                            <option key="GU" value="GU">
                              Guam
                            </option>
                            <option key="GT" value="GT">
                              Guatemala
                            </option>
                            <option key="GG" value="GG">
                              Guernsey
                            </option>
                            <option key="GN" value="GN">
                              Guinea
                            </option>
                            <option key="GW" value="GW">
                              Guinea-Bissau
                            </option>
                            <option key="GY" value="GY">
                              Guyana
                            </option>
                            <option key="HT" value="HT">
                              Haiti
                            </option>
                            <option key="HM" value="HM">
                              Heard Island and Mcdonald Islands
                            </option>
                            <option key="VA" value="VA">
                              Holy See (Vatican City State)
                            </option>
                            <option key="HN" value="HN">
                              Honduras
                            </option>
                            <option key="HK" value="HK">
                              Hong Kong
                            </option>
                            <option key="HU" value="HU">
                              Hungary
                            </option>
                            <option key="IS" value="IS">
                              Iceland
                            </option>
                            <option key="IN" value="IN">
                              India
                            </option>
                            <option key="ID" value="ID">
                              Indonesia
                            </option>
                            <option key="IR" value="IR">
                              Iran, Islamic Republic of
                            </option>
                            <option key="IQ" value="IQ">
                              Iraq
                            </option>
                            <option key="IE" value="IE">
                              Ireland
                            </option>
                            <option key="IM" value="IM">
                              Isle Of Man
                            </option>
                            <option key="IL" value="IL">
                              Israel
                            </option>
                            <option key="IT" value="IT">
                              Italy
                            </option>
                            <option key="JM" value="JM">
                              Jamaica
                            </option>
                            <option key="JP" value="JP">
                              Japan
                            </option>
                            <option key="JE" value="JE">
                              Jersey
                            </option>
                            <option key="JO" value="JO">
                              Jordan
                            </option>
                            <option key="KZ" value="KZ">
                              Kazakhstan
                            </option>
                            <option key="KE" value="KE">
                              Kenya
                            </option>
                            <option key="KI" value="KI">
                              Kiribati
                            </option>
                            <option key="KP" value="KP">
                              Korea, Democratic People's Republic of
                            </option>
                            <option key="KR" value="KR">
                              Korea, Republic of
                            </option>
                            <option key="KW" value="KW">
                              Kuwait
                            </option>
                            <option key="KG" value="KG">
                              Kyrgyzstan
                            </option>
                            <option key="LA" value="LA">
                              Lao People's Democratic Republic
                            </option>
                            <option key="LV" value="LV">
                              Latvia
                            </option>
                            <option key="LB" value="LB">
                              Lebanon
                            </option>
                            <option key="LS" value="LS">
                              Lesotho
                            </option>
                            <option key="LR" value="LR">
                              Liberia
                            </option>
                            <option key="LY" value="LY">
                              Libya
                            </option>
                            <option key="LI" value="LI">
                              Liechtenstein
                            </option>
                            <option key="LT" value="LT">
                              Lithuania
                            </option>
                            <option key="LU" value="LU">
                              Luxembourg
                            </option>
                            <option key="MO" value="MO">
                              Macao
                            </option>
                            <option key="MK" value="MK">
                              Macedonia, The Former Yugoslav Republic of
                            </option>
                            <option key="MG" value="MG">
                              Madagascar
                            </option>
                            <option key="MW" value="MW">
                              Malawi
                            </option>
                            <option key="MY" value="MY">
                              Malaysia
                            </option>
                            <option key="MV" value="MV">
                              Maldives
                            </option>
                            <option key="ML" value="ML">
                              Mali
                            </option>
                            <option key="MT" value="MT">
                              Malta
                            </option>
                            <option key="MH" value="MH">
                              Marshall Islands
                            </option>
                            <option key="MQ" value="MQ">
                              Martinique
                            </option>
                            <option key="MR" value="MR">
                              Mauritania
                            </option>
                            <option key="MU" value="MU">
                              Mauritius
                            </option>
                            <option key="YT" value="YT">
                              Mayotte
                            </option>
                            <option key="MX" value="MX">
                              Mexico
                            </option>
                            <option key="FM" value="FM">
                              Micronesia, Federated States of
                            </option>
                            <option key="MD" value="MD">
                              Moldova, Republic of
                            </option>
                            <option key="MC" value="MC">
                              Monaco
                            </option>
                            <option key="MN" value="MN">
                              Mongolia
                            </option>
                            <option key="ME" value="ME">
                              Montenegro
                            </option>
                            <option key="MS" value="MS">
                              Montserrat
                            </option>
                            <option key="MA" value="MA">
                              Morocco
                            </option>
                            <option key="MZ" value="MZ">
                              Mozambique
                            </option>
                            <option key="MM" value="MM">
                              Myanmar
                            </option>
                            <option key="NA" value="NA">
                              Namibia
                            </option>
                            <option key="NR" value="NR">
                              Nauru
                            </option>
                            <option key="NP" value="NP">
                              Nepal
                            </option>
                            <option key="NL" value="NL">
                              Netherlands
                            </option>
                            <option key="AN" value="AN">
                              Netherlands Antilles
                            </option>
                            <option key="NC" value="NC">
                              New Caledonia
                            </option>
                            <option key="NZ" value="NZ">
                              New Zealand
                            </option>
                            <option key="NI" value="NI">
                              Nicaragua
                            </option>
                            <option key="NE" value="NE">
                              Niger
                            </option>
                            <option key="NG" value="NG">
                              Nigeria
                            </option>
                            <option key="NU" value="NU">
                              Niue
                            </option>
                            <option key="NF" value="NF">
                              Norfolk Island
                            </option>
                            <option key="MP" value="MP">
                              Northern Mariana Islands
                            </option>
                            <option key="NO" value="NO">
                              Norway
                            </option>
                            <option key="OM" value="OM">
                              Oman
                            </option>
                            <option key="PK" value="PK">
                              Pakistan
                            </option>
                            <option key="PW" value="PW">
                              Palau
                            </option>
                            <option key="PS" value="PS">
                              Palestinian Territory, Occupied
                            </option>
                            <option key="PA" value="PA">
                              Panama
                            </option>
                            <option key="PG" value="PG">
                              Papua New Guinea
                            </option>
                            <option key="PY" value="PY">
                              Paraguay
                            </option>
                            <option key="PE" value="PE">
                              Peru
                            </option>
                            <option key="PH" value="PH">
                              Philippines
                            </option>
                            <option key="PN" value="PN">
                              Pitcairn
                            </option>
                            <option key="PL" value="PL">
                              Poland
                            </option>
                            <option key="PT" value="PT">
                              Portugal
                            </option>
                            <option key="PR" value="PR">
                              Puerto Rico
                            </option>
                            <option key="QA" value="QA">
                              Qatar
                            </option>
                            <option key="RE" value="RE">
                              Reunion
                            </option>
                            <option key="RO" value="RO">
                              Romania
                            </option>
                            <option key="RU" value="RU">
                              Russian Federation
                            </option>
                            <option key="RW" value="RW">
                              Rwanda
                            </option>
                            <option key="BL" value="BL">
                              Saint Barthelemy
                            </option>
                            <option key="SH" value="SH">
                              Saint Helena Ascension and Tristan Da Cunha
                            </option>
                            <option key="KN" value="KN">
                              Saint Kitts and Nevis
                            </option>
                            <option key="LC" value="LC">
                              Saint Lucia
                            </option>
                            <option key="MF" value="MF">
                              Saint Martin (French Part)
                            </option>
                            <option key="PM" value="PM">
                              Saint Pierre and Miquelon
                            </option>
                            <option key="VC" value="VC">
                              Saint Vincent and The Grenadines
                            </option>
                            <option key="WS" value="WS">
                              Samoa
                            </option>
                            <option key="SM" value="SM">
                              San Marino
                            </option>
                            <option key="ST" value="ST">
                              Sao Tome and Principe
                            </option>
                            <option key="SA" value="SA">
                              Saudi Arabia
                            </option>
                            <option key="SN" value="SN">
                              Senegal
                            </option>
                            <option key="RS" value="RS">
                              Serbia
                            </option>
                            <option key="SC" value="SC">
                              Seychelles
                            </option>
                            <option key="SL" value="SL">
                              Sierra Leone
                            </option>
                            <option key="SX" value="SX">
                              Sint Maarten (Dutch Part)
                            </option>
                            <option key="SK" value="SK">
                              Slovakia
                            </option>
                            <option key="SI" value="SI">
                              Slovenia
                            </option>
                            <option key="SB" value="SB">
                              Solomon Islands
                            </option>
                            <option key="SO" value="SO">
                              Somalia
                            </option>
                            <option key="ZA" value="ZA">
                              South Africa
                            </option>
                            <option key="GS" value="GS">
                              South Georgia and The South Sandwich Islands
                            </option>
                            <option key="SS" value="SS">
                              South Sudan
                            </option>
                            <option key="ES" value="ES">
                              Spain
                            </option>
                            <option key="LK" value="LK">
                              Sri Lanka
                            </option>
                            <option key="SD" value="SD">
                              Sudan
                            </option>
                            <option key="SR" value="SR">
                              Suriname
                            </option>
                            <option key="SJ" value="SJ">
                              Svalbard and Jan Mayen
                            </option>
                            <option key="SZ" value="SZ">
                              Swaziland
                            </option>
                            <option key="SE" value="SE">
                              Sweden
                            </option>
                            <option key="CH" value="CH">
                              Switzerland
                            </option>
                            <option key="SY" value="SY">
                              Syrian Arab Republic
                            </option>
                            <option key="TW" value="TW">
                              Taiwan
                            </option>
                            <option key="TJ" value="TJ">
                              Tajikistan
                            </option>
                            <option key="TZ" value="TZ">
                              Tanzania, United Republic of
                            </option>
                            <option key="TH" value="TH">
                              Thailand
                            </option>
                            <option key="TL" value="TL">
                              Timor-Leste
                            </option>
                            <option key="TG" value="TG">
                              Togo
                            </option>
                            <option key="TK" value="TK">
                              Tokelau
                            </option>
                            <option key="TO" value="TO">
                              Tonga
                            </option>
                            <option key="TT" value="TT">
                              Trinidad and Tobago
                            </option>
                            <option key="TN" value="TN">
                              Tunisia
                            </option>
                            <option key="TR" value="TR">
                              Turkey
                            </option>
                            <option key="TM" value="TM">
                              Turkmenistan
                            </option>
                            <option key="TC" value="TC">
                              Turks and Caicos Islands
                            </option>
                            <option key="TV" value="TV">
                              Tuvalu
                            </option>
                            <option key="UG" value="UG">
                              Uganda
                            </option>
                            <option key="UA" value="UA">
                              Ukraine
                            </option>
                            <option key="AE" value="AE">
                              United Arab Emirates
                            </option>
                            <option key="GB" value="GB">
                              United Kingdom
                            </option>
                            <option key="US" value="US">
                              United States
                            </option>
                            <option key="UM" value="UM">
                              United States Minor Outlying Islands
                            </option>
                            <option key="UY" value="UY">
                              Uruguay
                            </option>
                            <option key="UZ" value="UZ">
                              Uzbekistan
                            </option>
                            <option key="VU" value="VU">
                              Vanuatu
                            </option>
                            <option key="VE" value="VE">
                              Venezuela Bolivarian Republic of
                            </option>
                            <option key="VN" value="VN">
                              Viet Nam
                            </option>
                            <option key="VG" value="VG">
                              Virgin Islands, British
                            </option>
                            <option key="VI" value="VI">
                              Virgin Islands, U.S.
                            </option>
                            <option key="WF" value="WF">
                              Wallis and Futuna
                            </option>
                            <option key="EH" value="EH">
                              Western Sahara
                            </option>
                            <option key="YE" value="YE">
                              Yemen
                            </option>
                            <option key="ZM" value="ZM">
                              Zambia
                            </option>
                            <option key="ZW" value="ZW">
                              Zimbabwe
                            </option>
                          </select>
                          <div className="invalid-feedback">
                            Please select Foreign ID Country.
                          </div>
                        </div>

                        <div className="mb-2">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            Email
                            <span className="star">*</span>
                          </label>
                          <input
                            type="email"
                            className={`form-control ${
                              !validEmail ? "is-invalid" : ""
                            }`}
                            placeholder="Email"
                            id="Email"
                            value={email}
                            maxLength={100}
                            onChange={handleEmailChange}
                            required
                          />
                          <div className="invalid-feedback">
                            Please provide an Email Address.
                          </div>
                          {!validEmail && (
                            <p className="error-message">
                              Invalid email format. eg. abc@de.lk
                            </p>
                          )}
                        </div>
                        <div className="mb-2">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            Mobile
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Mobile"
                            id="Mobile"
                            value={mobile}
                            maxLength={20}
                            onChange={handleMobileChange}
                          />

                          {!validMobile && (
                            <p className="error-message">
                              Invalid mobile format. eg. +6591234567
                            </p>
                          )}
                        </div>
                        <div className="mb-2">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            Full Name
                            <span className="star">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Full Name"
                            value={fullName}
                            maxLength={100}
                            onChange={(e) => setFullName(e.target.value)}
                            required
                          />
                          <div className="invalid-feedback">
                            Please provide Full Name.
                          </div>
                        </div>
                      </div>
                      <div className="mb-3">
                        <ReCAPTCHA
                          ref={recaptchaRef}
                          sitekey={site_Key}
                          onChange={() => setIsCaptchaValid(true)}
                          onExpired={() => setIsCaptchaValid(false)}
                        />
                        {submitted && !isCaptchaValid && (
                          <div className="error-message">
                            Please complete the reCAPTCHA verification.
                          </div>
                        )}
                      </div>
                      <button
                        className="btn btn-success d-block mt-4"
                        type="submit"
                        disabled={isSubmiting}
                      >
                        Submit
                      </button>
                      {isSubmiting && <Loader />}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Contaier>
      <Footer />
    </>
  );
}

export default AccountRegistration;
